import { createContext, useContext, useMemo } from 'react';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentObjectTypeContext = /*#__PURE__*/createContext(undefined);
const ContentObjectTypeProvider = ({
  contentObjectType,
  contentGroupObjectType,
  children
}) => {
  const value = useMemo(() => ({
    contentObjectType,
    contentGroupObjectType,
    contentObjectTypeSingularNoun: I18n.text(`content-management-data-lib.contentObjectTypes.singular.${contentObjectType}`),
    contentObjectTypePluralNoun: I18n.text(`content-management-data-lib.contentObjectTypes.plural.${contentObjectType}`),
    contentGroupObjectTypeSingularNoun: contentGroupObjectType ? I18n.text(`content-management-data-lib.contentGroupObjectTypes.singular.${contentGroupObjectType}`) : undefined,
    contentGroupObjectTypePluralNoun: contentGroupObjectType ? I18n.text(`content-management-data-lib.contentGroupObjectTypes.plural.${contentGroupObjectType}`) : undefined
  }), [contentObjectType, contentGroupObjectType]);
  return /*#__PURE__*/_jsx(ContentObjectTypeContext.Provider, {
    value: value,
    children: children
  });
};
export default ContentObjectTypeProvider;
export const useContentObjectType = () => {
  const context = useContext(ContentObjectTypeContext);
  if (context === undefined) {
    throw new Error('useContentObjectType must be used within a ContentObjectTypeProvider');
  }
  return context;
};